var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SelectClient", { ref: "clientData" }),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-1" }, [
        _c(
          "div",
          { staticClass: "col-md-8" },
          [
            _vm._l(_vm.drugsInOrder, function (drug, index) {
              return [
                _c(
                  "div",
                  { staticClass: "drugSelected" },
                  [
                    _c("DrugSelect", {
                      ref: "selectedDrug",
                      refInFor: true,
                      attrs: {
                        customData: {
                          city_id: _vm.locality.city_id,
                          site_id: _vm.locality.project_id,
                        },
                        onSelect: (d, hardRefresh = null) =>
                          _vm.updateDrugData(d, index),
                        selectedDrug: drug,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-right mb-2" },
                      [
                        _c("LoadingButton", {
                          attrs: {
                            title: "Отправить препарат в чат",
                            loading: _vm.sendDrugToChatLoading,
                            type: "button",
                            color: _vm.$constants.SUCCESS_COLOR,
                            onClick: () => _vm.sendDrugToChat(drug, index),
                            className: "btn btn-outline-success",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "drugSelected" },
              [
                _c("DrugSelect", {
                  ref: "newDrug",
                  attrs: { onSelect: (d) => _vm.updateDrugData(d) },
                }),
              ],
              1
            ),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-4" },
          [
            _c("OrderPriceDetails", {
              ref: "priceDetails",
              attrs: { saveOrder: () => _vm.updateOrder() },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [_c("DeliveryData", { ref: "DeliveryData" })],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }